import { render } from "./Wip.vue?vue&type=template&id=3c94f3a7&scoped=true"
import script from "./Wip.vue?vue&type=script&lang=js"
export * from "./Wip.vue?vue&type=script&lang=js"

import "./Wip.vue?vue&type=style&index=0&id=3c94f3a7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c94f3a7"

export default script